import { useContext, useState } from "react";
import { Keyboard, ScrollView, StyleSheet, Text, TouchableWithoutFeedback, View } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import { createNumberMask } from "react-native-mask-input";
import IconButton from "../../components/ButtonIcon";
import PageTitle from "../../components/PageTitle";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import CaixaTextoInputIcone from "../../components/TextBoxIcon";
import { CreateFraction } from "../../services/Api/walletFraction";
import { GlobalContext } from "../../contexts/global";
import { formatMoneyBRL } from "../../helpers/util";
import { IS_WEB } from "@services/Config";

export default function WalletFractionForm({ navigation }) {
    const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
    const [amount, setAmount] = useState(null)
    const [validAmount, setValidAmount] = useState({
        isValid: true,
        invalidMessage: "Quantidade inválida",
    });
    const [value, setValue] = useState(null)
    const [validValue, setValidValue] = useState({
        isValid: true,
        invalidMessage: "Quantidade inválida",
    });

    const brlMask = createNumberMask({
        delimiter: '.',
        separator: ',',
        precision: 2,
    })

    const validData = (amount, value) => {
        let valid = true
        // if (!amount) {
        //     setValidAmount({ isValid: false, invalidMessage: "Digite uma quantidade" })
        //     valid = false
        // } else if (amount <= 0) {
        //     setValidAmount({ isValid: false, invalidMessage: "Quantidade tem que ser maior que 0" })
        //     valid = false
        // } else {
        //     setValidAmount({ isValid: true, invalidMessage: "" })
        // }

        if (!value) {
            setValidValue({ isValid: false, invalidMessage: "Digite um valor" })
            valid = false
        } else if (value <= 0) {
            setValidValue({ isValid: false, invalidMessage: "Valor tem que ser maior que 0" })
            valid = false
        } else {
            setValidValue({ isValid: true, invalidMessage: "" })
        }

        if (valid) {
            setLoading({ show: true, message: "Salvando fração" });
            let valueFraction = value / 100
            saveFraction(amount, valueFraction)
        }
    }

    const saveFraction = (amount, value) => {
        CreateFraction(amount, value).then((value) => {
            setShowAlert({
                type: "success",
                title: "Sucesso",
                message: "Fração salva",
                show: true,
                confirmText: "OK",
                pressConfirm: () => {
                    navigation.goBack()
                    setShowAlert({ ...showAlert, show: false });
                },
                showConfirmButton: true,
            });
        }).catch((error) => {
            setShowAlert({
                type: "alert",
                title: "Oops",
                message: (error.erro ?? error.message) ?? "Erro ao tentar salvar a fração",
                show: true,
                confirmText: "OK",
                pressCancel: () => { },
                pressConfirm: () => {
                    setShowAlert({ ...showAlert, show: false });
                },
                showConfirmButton: true,
            });
        }).finally(() => {
            setLoading({ show: false, message: "" });
        })
    }

    const totalReserved = () => {
        let amountReserved = amount ?? 0
        let valueReserved = value ?? 0
        return formatMoneyBRL((valueReserved / 100) * amountReserved)
    }

    return <PageTitle navigation={navigation} title={"Nova fração"}>
        <KeyboardAwareScrollView
            style={{ flex: 1, backgroundColor: Colors.WHITE }}
            keyboardShouldPersistTaps={"always"}
        >
            <TouchableWithoutFeedback onPress={!IS_WEB ? Keyboard.dismiss : null}>
                <ScrollView keyboardShouldPersistTaps={"always"}>
                    <CaixaTextoInputIcone
                        iconName={"currency-usd"}
                        placeholderInput={"Valor"}
                        onChangeTextInput={(masked, unmasked) => setValue(unmasked)}
                        value={value}
                        keyboardType={"numeric"}
                        styleBox={{ width: "100%", marginTop: 16 }}
                        maskInput={brlMask}
                        {...validValue}

                    />
                    <CaixaTextoInputIcone
                        iconName={"numeric"}
                        placeholderInput={"Quantidade (Opcional)"}
                        onChangeTextInput={(amount) => setAmount(amount)}
                        value={amount}
                        keyboardType={"numeric"}
                        styleBox={{ width: "100%" }}
                        {...validAmount}
                    />
                    {/* <View style={{
                        alignItems: "center"
                    }}>
                        <Text style={styles.reservedValueText}>{`O valor de ${totalReserved()} será reservado em sua carteira`}</Text>
                    </View> */}
                    <View style={styles.viewData}>
                        <IconButton
                            textoBotao={"Salvar fração"}
                            iconName={"content-save"}
                            onPress={() => validData(amount, value)}
                            estilo={{ backgroundColor: Colors.SUCCESS, width: "100%" }}
                        />
                    </View>
                </ScrollView>
            </TouchableWithoutFeedback>
        </KeyboardAwareScrollView>
    </PageTitle>
}

const styles = StyleSheet.create({
    viewData: {
        marginVertical: 8,
        flex: 1,
        justifyContent: "center",
    },
    reservedValueText: {
        marginVertical: 8,
        fontSize: Fonts.FONT_SIZE_16,
        color: Colors.GRAY_DARK,
        textAlign: "center",
    }
});